import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
    Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useState } from "react";
import { Alert, Snackbar } from "@mui/material";
import { useNavigate } from "react-router-dom";


const DataTableWalletFournisseur = ({ listTiersAccounts }) => {
    const navigate = useNavigate();

    const [infoAlertText, setInfoAlertText] = useState();
    const [openInfoAlert, setOpenInfoAlert] = useState(false);
    const { SearchBar } = Search;

    const MyExportCSV = (props) => {
        const handleClick = () => {
            props.onExport();
        };
        return (
            <div>
                <button className="btn btn-dark" onClick={handleClick}>
                    <i class="fas fa-download"></i> Télécharger CSV
                </button>
            </div>
        );
    };
    const onViewTransctionsHandler = (id) => {
        localStorage.setItem("idAccountSolde", id);
        const pdfWindow = window.open();
        pdfWindow.location.href = "/detailsTransactionAccountFournisseur";
        // navigate("/detailsTransactionAccountFournisseur");
    };

    const onViewChargerHandler = (idWallet, row) => {
        sessionStorage.setItem("idWallet", idWallet);
        sessionStorage.setItem("wallet", JSON.stringify(row));
        const pdfWindow = window.open();
        pdfWindow.location.href = "/chargerWalletFournisseur";
        // navigate("/chargerWalletFournisseur");
    };
    function tierFormatter(cell, row) {
        return (
            <span >
                {row.tier.matricule}-{row.tier.title}
            </span>
        );
    }
    function transactionsFormatter(cell, row) {
        return (
            <button
                style={{ width: 40 }}
                class="btn bg-black btn-sm "
                onClick={() => onViewTransctionsHandler(row.id)}
            >
                <i class="fas fa-money-bill-transfer"></i>
            </button>
        );
    }
    function chargerFormatter(cell, row) {
        return (
            <button
                style={{ width: 40 }}
                class="btn bg-black btn-sm "
                onClick={() => onViewChargerHandler(row.id, row)}
            >
                <i class="fas fa-money-bill-transfer"></i>
            </button>
        );
    }

    const columns = [

        {
            dataField: "title",
            text: "Nom",
            align: "center",
            headerAlign: "center",
            headerStyle: () => {
                return { width: "20%" };
            },
        }, {
            dataField: "id",
            text: "Tier",
            formatter: tierFormatter,
            align: "center",
            headerAlign: "center",
            headerStyle: () => {
                return { width: "40%" };
            },
        },
        {
            dataField: "solde",
            text: "Solde",
            align: "center",
            headerAlign: "center",
            headerStyle: () => {
                return { width: "20%" };
            },
        },
        {
            dataField: "id",
            text: "transactions",
            formatter: transactionsFormatter,
            align: "center",
            headerAlign: "center",
            headerStyle: () => {
                return { width: "10%" };
            },
        },
        {
            dataField: "id",
            text: "Charger",
            formatter: chargerFormatter,
            align: "center",
            headerAlign: "center",
            headerStyle: () => {
                return { width: "10%" };
            },
        },
    ];
    function handleTableChange({ products }) {
        return products;
    }
    const pageButtonRenderer = ({
        page,
        active,
        disable,
        title,
        onPageChange,
    }) => {
        const handleClick = (e) => {
            e.preventDefault();
            onPageChange(page);
        };
        const activeStyle = {};
        if (active) {
            activeStyle.backgroundColor = "black";
            activeStyle.color = "white";
        } else {
            activeStyle.backgroundColor = "white";
            activeStyle.color = "black";
        }
        if (typeof page === "string") {
            activeStyle.backgroundColor = "white";
            activeStyle.color = "black";
        }
        return (
            <li className="page-item">
                <button
                    className="btn btn-dark"
                    onClick={handleClick}
                    style={activeStyle}
                >
                    {page}
                </button>
            </li>
        );
    };
    const options = {
        pageButtonRenderer,
    };

    const handleInfoClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenInfoAlert(false);
    };

    return (
        <div className="card">
            <div className="card-header">
                <h3 className="card-title">Wallets Fournisseur </h3>
            </div>
            <div className="card-body">
                <ToolkitProvider
                    keyField="idPayementInfo"
                    data={listTiersAccounts}
                    columns={columns}
                    onTableChange={handleTableChange}
                    exportCSV
                    search
                >
                    {(props) => (
                        <div>
                            <div className="row ml-0">
                                <div>
                                    <SearchBar
                                        {...props.searchProps}
                                        className="custome-search-field"
                                        style={{ color: "black" }}
                                        placeholder="Chercher"
                                    ></SearchBar>
                                </div>
                                <div className="ml-auto mr-0">
                                    <MyExportCSV {...props.csvProps}></MyExportCSV>
                                </div>
                            </div>
                            <div className="row">
                                <BootstrapTable
                                    {...props.baseProps}
                                    pagination={paginationFactory(options)}
                                    striped
                                    hover
                                    condensed
                                // expandRow={expandRow}
                                />
                            </div>
                        </div>
                    )}
                </ToolkitProvider>
            </div>

            {openInfoAlert && (
                <Snackbar
                    open={openInfoAlert}
                    autoHideDuration={2000}
                    onClose={handleInfoClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                >
                    <Alert variant="filled" onClose={handleInfoClose} severity="info">
                        {infoAlertText}
                    </Alert>
                </Snackbar>
            )}

        </div>
    );





}
export default DataTableWalletFournisseur;